// ===========================
// System actions constants
// ===========================

// Sizing and collapsing constants
export const TOGGLE_COLLAPSED_NAV = 'TOGGLE_COLLAPSE_MENU';
export const WINDOW_WIDTH = 'WINDOW-WIDTH';

// Util actions
export const SHOW_MESSAGE = 'SHOW_MESSAGE';
export const HIDE_MESSAGE = 'HIDE_MESSAGE';
export const ON_SHOW_LOADER = 'ON_SHOW_LOADER';
export const ON_HIDE_LOADER = 'ON_HIDE_LOADER';
export const SHOW_APPLAUSE = 'SHOW_APPLAUSE';
export const HIDE_APPLAUSE = 'HIDE_APPLAUSE';

// Status bar
export const SET_STATUS_BAR = 'SET_STATUS_BAR';
export const SET_STATUS_BAR_BUTTONS = 'SET_STATUS_BAR_BUTTONS';
export const CHANGE_STATUS_BAR_SEARCH = 'CHANGE_STATUS_BAR_SEARCH';
export const CHANGE_STATUS_BAR_FILTER = 'CHANGE_STATUS_BAR_FILTER';
export const RESET_STATUS_BAR_FILTER = 'RESET_STATUS_BAR_FILTER';
export const CLEAR_STATUS_BAR = 'CLEAR_STATUS_BAR';

export const CHANGE_STATUS_BAR_SORT = 'CHANGE_STATUS_BAR_SORT';
// Top bar
export const SET_TOP_BAR = 'SET_TOP_BAR';

// Drawer
export const TOGGLE_NOTIFICATION_DRAWER = 'TOGGLE_NOTIFICATION_DRAWER';

//Settings
export const SAVE_SETTING = 'SAVE_SETTING';
export const CHANGE_SETTING = 'CHANGE_SETTING';
export const CHANGE_SEARCH = 'CHANGE_SEARCH';

// Timer
export const START_TIMER = 'START_TIMER';
export const STOP_TIMER = 'STOP_TIMER';
export const INIT_TIMER = 'INIT_TIMER';
export const DELETE_TIMER = 'DELETE_TIMER';
export const UPDATE_TIME = 'UPDATE_TIME';
export const START_TIMER_SUCCESS = 'START_TIMER_SUCCESS';
export const STOP_TIMER_SUCCESS = 'STOP_TIMER_SUCCESS';
export const INIT_TIMER_SUCCESS = 'INIT_TIMER_SUCCESS';
export const DELETE_TIMER_SUCCESS = 'DELETE_TIMER_SUCCESS';
export const UPDATE_TIME_SUCCESS = 'UPDATE_TIME_SUCCESS';
export const LOAD_TIMELOGS = 'LOAD_TIMELOGS';
export const LOAD_TIMELOGS_SUCCESS = 'LOAD_TIMELOGS_SUCCESS';
export const LOAD_TASK_TIMELOGS = 'LOAD_TASK_TIMELOGS';
export const LOAD_TASK_TIMELOGS_SUCCESS = 'LOAD_TASK_TIMELOGS_SUCCESS';
export const DELETE_TIMER_GROUP = 'DELETE_TIMER_GROUP';
export const DELETE_TIMER_GROUP_SUCCESS = 'DELETE_TIMER_GROUP_SUCCESS';
export const UPDATE_TIME_GROUP_SUCCESS = 'UPDATE_TIME_GROUP_SUCCESS';
export const SET_TIMER_STARTED_SOCKET = 'SET_TIMER_STARTED_SOCKET';
export const SET_TIMER_STOPPED_SOCKET = 'SET_TIMER_STOPPED_SOCKET';

// App error
export const TOGGLE_APP_ERROR = 'TOGGLE_APP_ERROR';
export const LOG_APP_ERROR = 'LOG_APP_ERROR';

// Auth module
// -----------

export const SET_AUTH_DATA = 'SET_AUTH_DATA';

// Sign in
export const SIGNIN_USER = 'SIGNIN_USER';
export const SIGNIN_USER_SUCCESS = 'SIGNIN_USER_SUCCESS';
export const SIGNIN_USER_ERROR = 'SIGNIN_USER_ERROR';

// Sigh out
export const SIGNOUT_USER = 'SIGNOUT_USER';
export const SIGNOUT_USER_SUCCESS = 'SIGNOUT_USER_SUCCESS';

// Reset password
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_ERROR = 'RESET_PASSWORD_ERROR';
export const PASSWORD_FILLING = 'PASSWORD_FILLING';

// After auth
export const INIT_URL = 'INIT_URL';
export const APP_STARTUP = 'APP_STARTUP';
export const APP_READY = 'APP_READY';
export const SET_AUTH_USER = 'SET_AUTH_USER';
export const UNAUTHORIZED = 'UNAUTHORIZED';

// Websocket subscriptions
export const SUBSCRIBE_ONLINE = 'SUBSCRIBE_ONLINE';
export const UNSUBSCRIBE_ONLINE = 'UNSUBSCRIBE_ONLINE';
export const SUBSCRIBE_NEW_FEED = 'SUBSCRIBE_NEW_FEED';
export const UNSUBSCRIBE_NEW_FEED = 'UNSUBSCRIBE_NEW_FEED';
export const SUBSCRIBE_TIMER_STARTED = 'SUBSCRIBE_TIMER_STARTED';
export const UNSUBSCRIBE_TIMER_STARTED = 'UNSUBSCRIBE_TIMER_STARTED';
export const SUBSCRIBE_TIMER_STOPPED = 'SUBSCRIBE_TIMER_STOPPED';
export const UNSUBSCRIBE_TIMER_STOPPED = 'UNSUBSCRIBE_TIMER_STOPPED';
export const SUBSCRIBE_CREDENTIAL_MODERATE_COUNT = 'SUBSCRIBE_CREDENTIAL_MODERATE_COUNT';
export const UNSUBSCRIBE_CREDENTIAL_MODERATE_COUNT = 'UNSUBSCRIBE_CREDENTIAL_MODERATE_COUNT';
export const SUBSCRIBE_EVENT_MODERATE_COUNT = 'SUBSCRIBE_EVENT_MODERATE_COUNT';
export const UNSUBSCRIBE_EVENT_MODERATE_COUNT = 'UNSUBSCRIBE_EVENT_MODERATE_COUNT';
export const SUBSCRIBE_TASK_CHANGES = 'SUBSCRIBE_TASK_CHANGES';
export const UNSUBSCRIBE_TASK_CHANGES = 'UNSUBSCRIBE_TASK_CHANGES';

// Invited users and profile filling users
// user profile
export const INVITE_USER = 'INVITE_USER';
export const INVITE_USER_SUCCESS = 'INVITE_USER_SUCCESS';
export const RE_INVITE_USER = 'RE_INVITE_USER';
export const LOAD_WIZARD_USER = 'LOAD_WIZARD_USER';
export const LOAD_WIZARD_USER_SUCCESS = 'LOAD_WIZARD_USER_SUCCESS';
export const FILL_USER = 'FILL_USER';

// user client profile
export const INVITE_USER_CLIENT = 'INVITE_USER_CLIENT';
export const INVITE_USER_CLIENT_SUCCESS = 'INVITE_USER_CLIENT_SUCCESS';
export const CREATE_USER_CLIENT_SUCCESS = 'CREATE_USER_CLIENT_SUCCESS';
export const LOAD_CLIENT_WIZARD_USER = 'LOAD_CLIENT_WIZARD_USER';
export const LOAD_CLIENT_WIZARD_USER_SUCCESS = 'LOAD_CLIENT_WIZARD_USER_SUCCESS';
export const FILL_USER_CLIENT = 'FILL_USER_CLIENT';

// ===========================
// Entities actions constants
// ===========================

// Meta information module
// -----------------------
export const LOAD_ENTITIES_UPDATED = 'LOAD_ENTITIES_UPDATED';
export const LOAD_ENTITIES_UPDATED_SUCCESS = 'LOAD_ENTITIES_UPDATED_SUCCESS';

// User module
// -----------

// Users
export const LOAD_USERS = 'LOAD_USERS';
export const LOAD_USERS_SUCCESS = 'LOAD_USERS_SUCCESS';
export const CLEAR_USERS = 'CLEAR_USERS';
export const SET_USERS_ONLINE = 'SET_USERS_ONLINE';
export const CHANGE_USER_PASSWORD = 'CHANGE_USER_PASSWORD';

export const LOAD_WORKSPACES = 'LOAD_WORKSPACES';
export const LOAD_WORKSPACES_SUCCESS = 'LOAD_WORKSPACES_SUCCESS';
export const SELECT_WORKSPACE = 'SELECT_WORKSPACE';
export const DETECT_CHANGE_WORKSPACE = 'DETECT_CHANGE_WORKSPACE';

export const LOAD_USER_BY_ID = 'LOAD_USER_BY_ID';
export const LOAD_USER_BY_ID_SUCCESS = 'LOAD_USER_BY_ID_SUCCESS';

export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USERNAME = 'UPDATE_USERNAME';

export const DISMISS_USER = 'DISMISS_USER';
export const DISMISS_USER_SUCCESS = 'DISMISS_USER_SUCCESS';
export const LOAD_DISMISS_USER = 'LOAD_DISMISS_USER';
export const LOAD_DISMISS_USER_SUCCESS = 'LOAD_DISMISS_USER_SUCCESS';
export const LOAD_DISMISS_USER_PROJECTS_SUCCESS = 'LOAD_DISMISS_USER_PROJECTS_SUCCESS';
export const LOAD_DISMISS_USER_SERVICES_SUCCESS = 'LOAD_DISMISS_USER_SERVICES_SUCCESS';
export const LOAD_DISMISS_USER_TASKS_SUCCESS = 'LOAD_DISMISS_USER_TASKS_SUCCESS';

export const DELETE_USER = 'DELETE_USER';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';

export const LOAD_STRUCTURE_CHART = 'LOAD_STRUCTURE_CHART';
export const LOAD_STRUCTURE_CHART_SUCCESS = 'LOAD_STRUCTURE_CHART_SUCCESS';

export const LOAD_USER_LAST_TASK = 'LOAD_USER_LAST_TASK';
export const LOAD_USER_LAST_TASK_SUCCESS = 'LOAD_USER_LAST_TASK_SUCCESS';

export const LOAD_MODERATE_COUNT = 'LOAD_MODERATE_COUNT';
export const LOAD_MODERATE_COUNT_SUCCESS = 'LOAD_MODERATE_COUNT_SUCCESS';

export const SET_CREDENTIAL_MODERATE_COUNT_SOCKET = 'SET_CREDENTIAL_MODERATE_COUNT_SOCKET';
export const SET_EVENT_MODERATE_COUNT_SOCKET = 'SET_EVENT_MODERATE_COUNT_SOCKET';

export const UPDATE_USER_COMPANY = 'UPDATE_USER_COMPANY';
export const UPDATE_USER_COMPANY_SUCCESS = 'UPDATE_USER_COMPANY_SUCCESS';

export const CONNECT_COMPANY_DRIVE = 'CONNECT_COMPANY_DRIVE';
export const CONNECT_COMPANY_DRIVE_RESULT = 'CONNECT_COMPANY_DRIVE_RESULT';

export const UNSET_COMPANY_INTEGRATION = 'UNSET_COMPANY_INTEGRATION';
export const UNSET_COMPANY_INTEGRATION_SUCCESS = 'UNSET_COMPANY_INTEGRATION_SUCCESS';

export const UPDATE_COMPANY_MASTER_PASSWORD = 'UPDATE_COMPANY_MASTER_PASSWORD';
export const UPDATE_COMPANY_MASTER_PASSWORD_SUCCESS = 'UPDATE_COMPANY_MASTER_PASSWORD_SUCCESS';

export const DISCONNECT_TELEGRAM = 'DISCONNECT_TELEGRAM';
export const DISCONNECT_TELEGRAM_SUCCESS = 'DISCONNECT_TELEGRAM_SUCCESS';

export const RESEND_CONFIRM_COMPANY = 'RESEND_CONFIRM_COMPANY';

// Salary history
export const LOAD_USER_SALARY_HISTORY = 'LOAD_USER_SALARY_HISTORY';
export const LOAD_USER_SALARY_HISTORY_SUCCESS = 'LOAD_USER_SALARY_HISTORY_SUCCESS';

export const CALCULATE_USER_SALARY = 'CALCULATE_USER_SALARY';
export const CALCULATE_USER_SALARY_SUCCESS = 'CALCULATE_USER_SALARY_SUCCESS';

export const UPDATE_SALARY_HISTORY = 'UPDATE_SALARY_HISTORY';
export const UPDATE_SALARY_HISTORY_SUCCESS = 'UPDATE_SALARY_HISTORY_SUCCESS';

// Departments
export const LOAD_DEPARTMENTS = 'LOAD_DEPARTMENTS';
export const LOAD_DEPARTMENTS_SUCCESS = 'LOAD_DEPARTMENTS_SUCCESS';
export const UPDATE_DEPARTMENT = 'UPDATE_DEPARTMENT';
export const UPDATE_DEPARTMENT_SUCCESS = 'UPDATE_DEPARTMENT_SUCCESS';
export const DELETE_DEPARTMENT = 'DELETE_DEPARTMENT';
export const DELETE_DEPARTMENT_SUCCESS = 'DELETE_DEPARTMENT_SUCCESS';
export const CLEAR_DEPARTMENTS = 'CLEAR_DEPARTMENTS';

// Positions
export const LOAD_POSITIONS = 'LOAD_POSITIONS';
export const LOAD_POSITIONS_SUCCESS = 'LOAD_POSITIONS_SUCCESS';
export const UPDATE_POSITION = 'UPDATE_POSITION';
export const UPDATE_POSITION_SUCCESS = 'UPDATE_POSITION_SUCCESS';
export const DELETE_POSITION = 'DELETE_POSITION';
export const DELETE_POSITION_SUCCESS = 'DELETE_POSITION_SUCCESS';
export const CLEAR_POSITIONS = 'CLEAR_POSITIONS';

// User roles
export const LOAD_USER_ROLES = 'LOAD_USER_ROLES';
export const LOAD_USER_ROLES_SUCCESS = 'LOAD_USER_ROLES_SUCCESS';
export const UPDATE_USER_ROLE = 'UPDATE_USER_ROLE';
export const UPDATE_USER_ROLE_SUCCESS = 'UPDATE_USER_ROLE_SUCCESS';
export const DELETE_USER_ROLE = 'DELETE_USER_ROLE';
export const DELETE_USER_ROLE_SUCCESS = 'DELETE_USER_ROLE_SUCCESS';

// User role assignment
export const UPDATE_ROLE_ASSIGNMENT = 'UPDATE_ROLE_ASSIGNMENT';
export const UPDATE_ROLE_ASSIGNMENT_SUCCESS = 'UPDATE_ROLE_ASSIGNMENT_SUCCESS';

// User contractors (Freelancers)
export const LOAD_FREELANCERS = 'LOAD_FREELANCERS';
export const LOAD_FREELANCERS_SUCCESS = 'LOAD_FREELANCERS_SUCCESS';
export const LOAD_CMS_LIST = 'LOAD_CMS_LIST';
export const LOAD_CMS_LIST_SUCCESS = 'LOAD_CMS_LIST_SUCCESS';
export const UPDATE_FREELANCER = 'UPDATE_FREELANCER';
export const UPDATE_FREELANCER_SUCCESS = 'UPDATE_FREELANCER_SUCCESS';
export const DELETE_FREELANCER = 'DELETE_FREELANCER';
export const DELETE_FREELANCER_SUCCESS = 'DELETE_FREELANCER_SUCCESS';

// User client profiles
export const LOAD_CLIENT_PROFILES = 'LOAD_CLIENT_PROFILES';
export const LOAD_CLIENT_PROFILES_SUCCESS = 'LOAD_CLIENT_PROFILES_SUCCESS';
export const LOAD_CLIENT_USER_BY_ID = 'LOAD_CLIENT_USER_BY_ID';
export const LOAD_CLIENT_USER_BY_ID_SUCCESS = 'LOAD_CLIENT_USER_BY_ID_SUCCESS';
export const UPDATE_CLIENT_USER = 'UPDATE_CLIENT_USER';
export const UPDATE_CLIENT_USER_SUCCESS = 'UPDATE_CLIENT_USER_SUCCESS';
export const CLEAR_CLIENT_PROFILES = 'CLEAR_CLIENT_PROFILES';
export const DELETE_CLIENT_PROFILE = 'DELETE_CLIENT_PROFILE';
export const DELETE_CLIENT_PROFILE_SUCCESS = 'DELETE_CLIENT_PROFILE_SUCCESS';

export const LOAD_COMPANIES = 'LOAD_COMPANIES';
export const LOAD_COMPANIES_SUCCESS = 'LOAD_COMPANIES_SUCCESS';
export const LOAD_COMPANY_BY_ID = 'LOAD_COMPANY_BY_ID';
export const LOAD_COMPANY_BY_ID_SUCCESS = 'LOAD_COMPANY_BY_ID_SUCCESS';

// Project module
// -----------

// Projects
export const LOAD_PROJECTS = 'LOAD_PROJECTS';
export const LOAD_PROJECTS_NAME = 'LOAD_PROJECTS_NAME';
export const LOAD_PROJECTS_SUCCESS = 'LOAD_PROJECTS_SUCCESS';
export const LOAD_PROJECTS_NAME_SUCCESS = 'LOAD_PROJECTS_NAME_SUCCESS';
export const LOAD_PROJECT_BY_ID = 'LOAD_PROJECT_BY_ID';
export const LOAD_PROJECT_BY_ID_SUCCESS = 'LOAD_PROJECT_BY_ID_SUCCESS';
export const LOAD_DRAWER_PROJECTS = 'LOAD_DRAWER_PROJECTS';
export const LOAD_DRAWER_PROJECTS_SUCCESS = 'LOAD_DRAWER_PROJECTS_SUCCESS';
export const UPDATE_PROJECT_STATUS = 'UPDATE_PROJECT_STATUS';
export const UPDATE_PROJECT_DESCRIPTION = 'UPDATE_PROJECT_DESCRIPTION';
export const UPDATE_PROJECT_SUCCESS = 'UPDATE_PROJECT_SUCCESS';
export const CREATE_PROJECT_SUCCESS = 'CREATE_PROJECT_SUCCESS';
export const DELETE_PROJECT = 'DELETE_PROJECT';
export const DELETE_PROJECT_SUCCESS = 'DELETE_PROJECT_SUCCESS';
export const CREATE_TEAM_MAP = 'CREATE_TEAM_MAP';
export const CREATE_TEAM_MAP_SUCCESS = 'CREATE_TEAM_MAP_SUCCESS';
export const DELETE_TEAM_MAP = 'DELETE_TEAM_MAP';
export const DELETE_TEAM_MAP_SUCCESS = 'DELETE_TEAM_MAP_SUCCESS';
export const CONNECT_PROJECT_WEBMASTER = 'CONNECT_PROJECT_WEBMASTER';
export const ADD_PROJECT_FAVORITE = 'ADD_PROJECT_FAVORITE';
export const ADD_PROJECT_FAVORITE_SUCCESS = 'ADD_PROJECT_FAVORITE_SUCCESS';
export const DELETE_PROJECT_FAVORITE = 'DELETE_PROJECT_FAVORITE';
export const DELETE_PROJECT_FAVORITE_SUCCESS = 'DELETE_PROJECT_FAVORITE_SUCCESS';
export const LOAD_PROJECTS_FAVORITE_MAP = 'LOAD_PROJECTS_FAVORITE_MAP';
export const LOAD_PROJECTS_FAVORITE_MAP_SUCCESS = 'LOAD_PROJECTS_FAVORITE_MAP_SUCCESS';
export const LOAD_PROJECT_FILE_LIST = 'LOAD_PROJECT_FILE_LIST';
export const LOAD_PROJECT_FILE_LIST_SUCCESS = 'LOAD_PROJECT_FILE_LIST_SUCCESS';
export const SYNC_PROJECT_DRIVE = 'SYNC_PROJECT_DRIVE';
export const SYNC_PROJECT_DRIVE_SUCCESS = 'SYNC_PROJECT_DRIVE_SUCCESS';
export const UPDATE_PROJECT_MONITORING_SETTINGS = 'UPDATE_PROJECT_MONITORING_SETTINGS';
export const UPDATE_PROJECT_MONITORING_SETTINGS_SUCCESS = 'UPDATE_PROJECT_MONITORING_SETTINGS_SUCCESS';
export const RUN_PROJECT_MONITORING = 'RUN_PROJECT_MONITORING';
export const RUN_PROJECT_MONITORING_SUCCESS = 'RUN_PROJECT_MONITORING_SUCCESS';
export const CONNECT_PROJECT_GOOGLE_SEARCH = 'CONNECT_PROJECT_GOOGLE_SEARCH';
export const CONNECT_PROJECT_GOOGLE_SEARCH_SUCCESS = 'CONNECT_PROJECT_GOOGLE_SEARCH_SUCCESS';
export const SELECT_PROJECT_GOOGLE_SEARCH = 'SELECT_PROJECT_GOOGLE_SEARCH';

export const LOAD_PROJECTS_DRIVE_FOLDERS = 'LOAD_PROJECTS_DRIVE_FOLDERS';
export const LOAD_PROJECTS_DRIVE_FOLDERS_SUCCESS = 'LOAD_PROJECTS_DRIVE_FOLDERS_SUCCESS';
export const UNSET_PROJECT_INTEGRATION = 'UNSET_PROJECT_INTEGRATION';

// Projects services map
export const LOAD_PROJECTS_SERVICES_MAP = 'LOAD_PROJECTS_SERVICES_MAP';
export const LOAD_PROJECTS_SERVICES_MAP_SUCCESS = 'LOAD_PROJECTS_SERVICES_MAP_SUCCESS';
export const LOAD_PROJECT_SERVICE_HISTORY = 'LOAD_PROJECT_SERVICE_HISTORY';
export const LOAD_PROJECT_SERVICE_HISTORY_SUCCESS = 'LOAD_PROJECT_SERVICE_HISTORY_SUCCESS';
export const UPDATE_PROJECT = 'UPDATE_PROJECT';
export const UPDATE_SERVICE_MAP = 'UPDATE_SERVICE_MAP';
export const ARCHIVE_SERVICE_MAP = 'ARCHIVE_SERVICE_MAP';
export const UPDATE_SERVICE_MAP_SUCCESS = 'UPDATE_SERVICE_MAP_SUCCESS';
export const DELETE_SERVICE_MAP = 'DELETE_SERVICE_MAP';
export const DELETE_SERVICE_MAP_SUCCESS = 'DELETE_SERVICE_MAP_SUCCESS';
export const UPDATE_PROJECT_SERVICE_HISTORY = 'UPDATE_PROJECT_SERVICE_HISTORY';
export const UPDATE_PROJECT_SERVICE_HISTORY_SUCCESS = 'UPDATE_PROJECT_SERVICE_HISTORY_SUCCESS';

// Service module
// -----------

// Services
export const LOAD_SERVICES = 'LOAD_SERVICES';
export const LOAD_SERVICES_SUCCESS = 'LOAD_SERVICES_SUCCESS';
export const UPDATE_SERVICE = 'UPDATE_SERVICE';
export const UPDATE_SERVICE_SUCCESS = 'UPDATE_SERVICE_SUCCESS';
export const DELETE_SERVICE = 'DELETE_SERVICE';
export const DELETE_SERVICE_SUCCESS = 'DELETE_SERVICE_SUCCESS';
export const CLEAR_SERVICES = 'CLEAR_SERVICES';

// Client module
// -----------

// Clients
export const LOAD_CLIENTS = 'LOAD_CLIENTS';
export const LOAD_CLIENTS_SUCCESS = 'LOAD_CLIENTS_SUCCESS';
export const LOAD_CLIENTS_TABLE_SUCCESS = 'LOAD_CLIENTS_TABLE_SUCCESS';
export const LOAD_CLIENT_BY_ID_SUCCESS = 'LOAD_CLIENT_BY_ID_SUCCESS';
export const UPDATE_CLIENT = 'UPDATE_CLIENT';
export const UPDATE_CLIENT_SUCCESS = 'UPDATE_CLIENT_SUCCESS';
export const DELETE_CLIENT = 'DELETE_CLIENT';
export const DELETE_CLIENT_SUCCESS = 'DELETE_CLIENT_SUCCESS';
export const CREATE_PROJECT_CLIENT_SUCCESS = 'CREATE_PROJECT_CLIENT_SUCCESS';
export const TOGGLE_CLIENT_VIEW = 'TOGGLE_CLIENT_VIEW';

// Client payments
export const LOAD_CLIENT_PAYMENTS = 'LOAD_CLIENT_PAYMENTS';
export const LOAD_CLIENT_PAYMENTS_SUCCESS = 'LOAD_CLIENT_PAYMENTS_SUCCESS';
export const UPDATE_CLIENT_PAYMENT = 'UPDATE_CLIENT_PAYMENT';
export const UPDATE_CLIENT_PAYMENT_SUCCESS = 'UPDATE_CLIENT_PAYMENT_SUCCESS';
export const DELETE_CLIENT_PAYMENT = 'DELETE_CLIENT_PAYMENT';
export const DELETE_CLIENT_PAYMENT_SUCCESS = 'DELETE_CLIENT_PAYMENT_SUCCESS';

// Client invoices
export const LOAD_CLIENT_INVOICE = 'LOAD_CLIENT_INVOICE';
export const LOAD_CLIENT_INVOICE_SUCCESS = 'LOAD_CLIENT_INVOICE_SUCCESS';
export const UPDATE_CLIENT_INVOICE = 'UPDATE_CLIENT_INVOICE';
export const UPDATE_CLIENT_INVOICE_SUCCESS = 'UPDATE_CLIENT_INVOICE_SUCCESS';
export const DELETE_CLIENT_INVOICE = 'DELETE_CLIENT_INVOICE';
export const DELETE_CLIENT_INVOICE_SUCCESS = 'DELETE_CLIENT_INVOICE_SUCCESS';
export const LOAD_CLIENT_INVOICES_TABLE_SUCCESS = 'LOAD_CLIENT_INVOICES_TABLE_SUCCESS';
export const LOAD_CLIENT_INVOICE_BY_ID = 'LOAD_CLIENT_INVOICE_BY_ID';
export const LOAD_CLIENT_INVOICE_BY_ID_SUCCESS = 'LOAD_CLIENT_INVOICE_BY_ID_SUCCESS';

// Legal entity module
// -----------

// Legal entities
export const LOAD_LEGAL_ENTITIES = 'LOAD_LEGAL_ENTITIES';
export const LOAD_LEGAL_ENTITIES_SUCCESS = 'LOAD_LEGAL_ENTITIES_SUCCESS';
export const UPDATE_LEGAL_ENTITY = 'UPDATE_LEGAL_ENTITY';
export const UPDATE_LEGAL_ENTITY_SUCCESS = 'UPDATE_LEGAL_ENTITY_SUCCESS';
export const DELETE_LEGAL_ENTITY = 'DELETE_LEGAL_ENTITY';
export const DELETE_LEGAL_ENTITY_SUCCESS = 'DELETE_LEGAL_ENTITY_SUCCESS';
export const LOAD_DADATA = 'LOAD_DADATA';

// Credential module
// -----------

// Credentials
export const LOAD_CREDENTIALS = 'LOAD_CREDENTIAL';
export const LOAD_CREDENTIALS_SUCCESS = 'LOAD_CREDENTIAL_SUCCESS';
export const LOAD_MODERATED_CREDENTIALS_SUCCESS = 'LOAD_MODERATED_CREDENTIALS_SUCCESS';
export const LOAD_CREDENTIAL_BY_ID = 'LOAD_CREDENTIAL_BY_ID';
export const LOAD_CREDENTIAL_BY_ID_SUCCESS = 'LOAD_CREDENTIAL_BY_ID_SUCCESS';
export const DELETE_CREDENTIAL = 'DELETE_CREDENTIAL';
export const DELETE_CREDENTIAL_SUCCESS = 'DELETE_CREDENTIAL_SUCCESS';
export const UPDATE_CREDENTIAL = 'UPDATE_CREDENTIAL';
export const UPDATE_CREDENTIAL_SUCCESS = 'UPDATE_CREDENTIAL_SUCCESS';
export const SET_MODERATED_COUNT = 'SET_MODERATED_COUNT';
export const CHECK_CREDENTIAL_PASSWORD = 'CHECK_CREDENTIAL_PASSWORD';
export const LOAD_CREDENTIAL_FIELDS = 'LOAD_CREDENTIAL_FIELDS';

// Credential groups
export const LOAD_CREDENTIAL_GROUPS = 'LOAD_CREDENTIAL_GROUPS';
export const LOAD_CREDENTIAL_GROUPS_SUCCESS = 'LOAD_CREDENTIAL_GROUPS_SUCCESS';
export const DELETE_CREDENTIAL_GROUP = 'DELETE_CREDENTIAL_GROUP';
export const DELETE_CREDENTIAL_GROUP_SUCCESS = 'DELETE_CREDENTIAL_GROUP_SUCCESS';
export const UPDATE_CREDENTIAL_GROUP = 'UPDATE_CREDENTIAL_GROUP';
export const UPDATE_CREDENTIAL_GROUP_SUCCESS = 'UPDATE_CREDENTIAL_GROUP_SUCCESS';
export const CLEAR_CREDENTIAL_GROUPS = 'CLEAR_CREDENTIAL_GROUPS';

// Credential 'favorite' actions
export const ADD_TO_FAVORITE = 'ADD_TO_FAVORITE';
export const CHANGE_FAVORITE = 'CHANGE_FAVORITE';
export const REMOVE_FROM_FAVORITE = 'REMOVE_FROM_FAVORITE';

// Task module
// -----------

// Task
export const LOAD_TASKS = 'LOAD_TASKS';
export const LOAD_TASKS_SUCCESS = 'LOAD_TASKS_SUCCESS';
export const LOAD_TASKS_TREE_SUCCESS = 'LOAD_TASKS_TREE_SUCCESS';
export const DESTROY_TASKS_TREE = 'DESTROY_TASKS_TREE';
export const LOAD_TASKS_MIGRATE_SUCCESS = 'LOAD_TASKS_MIGRATE_SUCCESS';
export const LOAD_TASKS_COMMENT_MIGRATE_SUCCESS = 'LOAD_TASKS_COMMENT_MIGRATE_SUCCESS';
export const LOAD_TASK_LIST_SUCCESS = 'LOAD_TASK_LIST_SUCCESS';
export const LOAD_SUBTASKS_LIST_SUCCESS = 'LOAD_SUBTASKS_LIST_SUCCESS';
export const LOAD_BOARD_TASKS = 'LOAD_BOARD_TASKS';
export const LOAD_BOARD_TASKS_SUCCESS = 'LOAD_BOARD_TASKS_SUCCESS';
export const RESET_BOARD_TASKS = 'RESET_BOARD_TASKS';
export const LOAD_TASK_BY_ID = 'LOAD_TASK_BY_ID';
export const LOAD_TASK_BY_ID_SUCCESS = 'LOAD_TASK_BY_ID_SUCCESS';
export const UPDATE_TASK = 'UPDATE_TASK';
export const UPDATE_TASK_ORDER = 'UPDATE_TASK_ORDER';
export const UPDATE_TASK_ORDER_SUCCESS = 'UPDATE_TASK_ORDER_SUCCESS';
export const UPDATE_TASK_SUCCESS = 'UPDATE_TASK_SUCCESS';
export const UPDATE_TASK_IN_REPORT_SUCCESS = 'UPDATE_TASK_IN_REPORT_SUCCESS';
export const DELETE_TASK = 'DELETE_TASK';
export const DELETE_TASK_SUCCESS = 'DELETE_TASK_SUCCESS';
export const TASK_SEND_EMOJI = 'TASK_SEND_EMOJI';
export const TASK_SEND_EMOJI_SUCCESS = 'TASK_SEND_EMOJI_SUCCESS';
export const TASK_VIEW_COMMENT_NOTIFICATIONS = 'TASK_VIEW_COMMENT_NOTIFICATIONS';
export const TASK_VIEW_COMMENT_NOTIFICATIONS_SUCCESS = 'TASK_VIEW_COMMENT_NOTIFICATIONS_SUCCESS';
export const LOAD_TASK_MIGRATE_INFO = 'LOAD_TASK_MIGRATE_INFO';
export const LOAD_TASK_MIGRATE_INFO_SUCCESS = 'LOAD_TASK_MIGRATE_INFO_SUCCESS';
export const TASK_MIGRATE = 'TASK_MIGRATE';
export const UPDATE_TASKS = 'UPDATE_TASKS';
export const UPDATE_TASKS_SUCCESS = 'UPDATE_TASKS_SUCCESS';
export const LOAD_DRAWER_TASKS_SUCCESS = 'LOAD_DRAWER_TASKS_SUCCESS';
export const APPEND_ACTIVITY_LOG = 'APPEND_ACTIVITY_LOG';
export const RESET_TASK_DRAG = 'RESET_TASK_DRAG';

// Task label
export const LOAD_TASK_LABELS = 'LOAD_TASK_LABELS';
export const LOAD_TASK_LABELS_SUCCESS = 'LOAD_TASK_LABELS_SUCCESS';
export const UPDATE_TASK_LABEL = 'UPDATE_TASK_LABEL';
export const UPDATE_TASK_LABEL_SUCCESS = 'UPDATE_TASK_LABEL_SUCCESS';
export const DELETE_TASK_LABEL = 'DELETE_TASK_LABEL';
export const DELETE_TASK_LABEL_SUCCESS = 'DELETE_TASK_LABEL_SUCCESS';
export const LOAD_TASK_LABEL_GROUPS = 'LOAD_TASK_LABEL_GROUPS';
export const LOAD_TASK_LABEL_GROUPS_SUCCESS = 'LOAD_TASK_LABEL_GROUPS_SUCCESS';
export const UPDATE_TASK_LABEL_GROUP = 'UPDATE_TASK_LABEL_GROUP';
export const UPDATE_TASK_LABEL_GROUP_SUCCESS = 'UPDATE_TASK_LABEL_GROUP_SUCCESS';
export const DELETE_TASK_LABEL_GROUP = 'DELETE_TASK_LABEL_GROUP';
export const DELETE_TASK_LABEL_GROUP_SUCCESS = 'DELETE_TASK_LABEL_GROUP_SUCCESS';
export const CLEAR_TASK_LABELS = 'CLEAR_TASK_LABELS';

// Task status
export const LOAD_TASK_STATUSES = 'LOAD_TASK_STATUSES';
export const LOAD_TASK_STATUSES_SUCCESS = 'LOAD_TASK_STATUSES_SUCCESS';
export const LOAD_TASK_STATUSES_COUNTERS = 'LOAD_TASK_STATUSES_COUNTERS';
export const LOAD_TASK_STATUSES_COUNTERS_SUCCESS = 'LOAD_TASK_STATUSES_COUNTERS_SUCCESS';
export const UPDATE_TASK_STATUS = 'UPDATE_TASK_STATUS';
export const UPDATE_TASK_STATUS_SUCCESS = 'UPDATE_TASK_STATUS_SUCCESS';
export const DELETE_TASK_STATUS = 'DELETE_TASK_STATUS';
export const DELETE_TASK_STATUS_SUCCESS = 'DELETE_TASK_STATUS_SUCCESS';
export const CLEAR_TASK_STATUSES = 'CLEAR_TASK_STATUSES';
export const LOAD_WORKFLOWS = 'LOAD_WORKFLOWS';
export const LOAD_WORKFLOWS_SUCCESS = 'LOAD_WORKFLOWS_SUCCESS';
export const UPDATE_WORKFLOW = 'UPDATE_WORKFLOW';
export const UPDATE_WORKFLOW_SUCCESS = 'UPDATE_WORKFLOW_SUCCESS';
export const DELETE_WORKFLOW = 'DELETE_WORKFLOW';
export const DELETE_WORKFLOW_SUCCESS = 'DELETE_WORKFLOW_SUCCESS';
export const CHANGE_STATUS_POSITION = 'CHANGE_STATUS_POSITION';
export const CHANGE_STATUS_POSITION_SUCCESS = 'CHANGE_STATUS_POSITION_SUCCESS';

//Task checklist
export const UPDATE_CHECKLIST = 'UPDATE_CHECKLIST';
export const UPDATE_CHECKLIST_SUCCESS = 'UPDATE_CHECKLIST_SUCCESS';
export const DELETE_CHECKLIST = 'DELETE_CHECKLIST';
export const DELETE_CHECKLIST_SUCCESS = 'DELETE_CHECKLIST_SUCCESS';
export const UPDATE_CHECKLIST_ITEM = 'UPDATE_CHECKLIST_ITEM';
export const UPDATE_CHECKLIST_ITEM_SUCCESS = 'UPDATE_CHECKLIST_ITEM_SUCCESS';
export const DELETE_CHECKLIST_ITEM = 'DELETE_CHECKLIST_ITEM';
export const DELETE_CHECKLIST_ITEM_SUCCESS = 'DELETE_CHECKLIST_ITEM_SUCCESS';
export const CHECK_CHECKLIST_ITEM = 'CHECK_CHECKLIST_ITEM';
export const CHECK_CHECKLIST_ITEM_SUCCESS = 'CHECK_CHECKLIST_ITEM_SUCCESS';
export const DRAG_CHECKLIST_ITEM = 'DRAG_CHECKLIST_ITEM';
export const DRAG_CHECKLIST_ITEM_SUCCESS = 'DRAG_CHECKLIST_ITEM_SUCCESS';

//Task template
export const LOAD_TASK_TEMPLATE_CONSTANTS = 'LOAD_TASK_TEMPLATE_CONSTANTS';
export const LOAD_TASK_TEMPLATES = 'LOAD_TASK_TEMPLATES';
export const LOAD_TASK_TEMPLATES_SUCCESS = 'LOAD_TASK_TEMPLATES_SUCCESS';
export const LOAD_TASK_TEMPLATE = 'LOAD_TASK_TEMPLATE';
export const LOAD_TASK_TEMPLATE_SUCCESS = 'LOAD_TASK_TEMPLATE_SUCCESS';
export const UPDATE_TASK_TEMPLATE = 'UPDATE_TASK_TEMPLATE';
export const UPDATE_TASK_TEMPLATE_SUCCESS = 'UPDATE_TASK_TEMPLATE_SUCCESS';
export const DELETE_TASK_TEMPLATE = 'DELETE_TASK_TEMPLATE';
export const DELETE_TASK_TEMPLATE_SUCCESS = 'DELETE_TASK_TEMPLATE_SUCCESS';
export const APPLY_TASK_TEMPLATE = 'APPLY_TASK_TEMPLATE';
export const APPLY_TASK_TEMPLATE_SUCCESS = 'APPLY_TASK_TEMPLATE_SUCCESS';

//Task schedule
export const UPDATE_TASK_SCHEDULE = 'UPDATE_TASK_SCHEDULE';
export const UPDATE_TASK_SCHEDULE_SUCCESS = 'UPDATE_TASK_SCHEDULE_SUCCESS';
export const LOAD_TASK_SCHEDULE = 'LOAD_TASK_SCHEDULE';
export const LOAD_TASK_SCHEDULE_SUCCESS = 'LOAD_TASK_SCHEDULE_SUCCESS';
export const DELETE_TASK_SCHEDULE = 'DELETE_TASK_SCHEDULE';
export const DELETE_TASK_SCHEDULE_SUCCESS = 'DELETE_TASK_SCHEDULE_SUCCESS';
export const LOAD_SCHEDULE_TASKS_SUCCESS = 'LOAD_SCHEDULE_TASKS_SUCCESS';

// Report module
// -----------

export const LOAD_DEFAULT_REPORT = 'LOAD_DEFAULT_REPORT';
export const LOAD_DETAIL_REPORT = 'LOAD_DETAIL_REPORT';
export const LOAD_USER_REPORT = 'LOAD_USER_REPORT';
export const LOAD_REPORT_SUCCESS = 'LOAD_REPORT_SUCCESS';
export const LOAD_REPORT_PROJECTS_SUCCESS = 'LOAD_REPORT_PROJECTS_SUCCESS';
export const CHANGE_REPORT_FILTER = 'CHANGE_REPORT_FILTER';
export const EXPORT_REPORT = 'EXPORT_REPORT';

// Comment module
// -----------

// Comment
export const CREATE_COMMENT = 'CREATE_COMMENT';
export const CREATE_COMMENT_SUCCESS = 'CREATE_COMMENT_SUCCESS';
export const CREATE_COMMENT_ERROR = 'CREATE_COMMENT_ERROR';
export const UPDATE_COMMENT = 'UPDATE_COMMENT';
export const MIGRATE_COMMENT = 'MIGRATE_COMMENT';
export const UPDATE_COMMENT_SUCCESS = 'UPDATE_COMMENT_SUCCESS';
export const UPDATE_COMMENT_ERROR = 'UPDATE_COMMENT_ERROR';
export const DELETE_COMMENT = 'DELETE_COMMENT';
export const DELETE_COMMENT_SUCCESS = 'DELETE_COMMENT_SUCCESS';
export const SEND_EMOJI = 'SEND_EMOJI';
export const SEND_EMOJI_SUCCESS = 'SEND_EMOJI_SUCCESS';
export const LOAD_TASK_COMMENTS = 'LOAD_TASK_COMMENTS';
export const LOAD_TASK_COMMENTS_SUCCESS = 'LOAD_TASK_COMMENTS_SUCCESS';

// Article module
// --------------

// Article
export const LOAD_ARTICLES = 'LOAD_ARTICLES';
export const LOAD_ARTICLES_SUCCESS = 'LOAD_ARTICLES_SUCCESS';
export const LOAD_ARTICLE_BY_ID = 'LOAD_ARTICLE_BY_ID';
export const LOAD_ARTICLE_BY_ID_SUCCESS = 'LOAD_ARTICLE_BY_ID_SUCCESS';
export const UPDATE_ARTICLE = 'UPDATE_ARTICLE';
export const UPDATE_ARTICLE_SUCCESS = 'UPDATE_ARTICLE_SUCCESS';
export const DELETE_ARTICLE = 'DELETE_ARTICLE';
export const DELETE_ARTICLE_SUCCESS = 'DELETE_ARTICLE_SUCCESS';

// Article category
export const LOAD_ARTICLE_CATEGORIES = 'LOAD_ARTICLE_CATEGORIES';
export const LOAD_ARTICLE_CATEGORIES_SUCCESS = 'LOAD_ARTICLE_CATEGORIES_SUCCESS';
export const LOAD_CATEGORIES_LAST_ARTICLES = 'LOAD_CATEGORIES_LAST_ARTICLES';
export const LOAD_CATEGORIES_LAST_ARTICLES_SUCCESS = 'LOAD_CATEGORIES_LAST_ARTICLES_SUCCESS';
export const UPDATE_ARTICLE_CATEGORY = 'UPDATE_ARTICLE_CATEGORY';
export const UPDATE_ARTICLE_CATEGORY_SUCCESS = 'UPDATE_ARTICLE_CATEGORY_SUCCESS';
export const DELETE_ARTICLE_CATEGORY = 'DELETE_ARTICLE_CATEGORY';
export const DELETE_ARTICLE_CATEGORY_SUCCESS = 'DELETE_ARTICLE_CATEGORY_SUCCESS';
export const CLEAR_ARTICLE_CATEGORIES = 'CLEAR_ARTICLE_CATEGORIES';

// Article tag
export const LOAD_ARTICLE_TAGS = 'LOAD_ARTICLE_TAGS';
export const LOAD_ARTICLE_TAGS_SUCCESS = 'LOAD_ARTICLE_TAGS_SUCCESS';
export const UPDATE_ARTICLE_TAG = 'UPDATE_ARTICLE_TAG';
export const UPDATE_ARTICLE_TAG_SUCCESS = 'UPDATE_ARTICLE_TAG_SUCCESS';
export const DELETE_ARTICLE_TAG = 'DELETE_ARTICLE_TAG';
export const DELETE_ARTICLE_TAG_SUCCESS = 'DELETE_ARTICLE_TAG_SUCCESS';
export const CLEAR_ARTICLE_TAGS = 'CLEAR_ARTICLE_TAGS';

// Event module
// --------------

//Event schedule
export const LOAD_EVENT_SCHEDULES = 'LOAD_EVENT_SCHEDULES';
export const LOAD_EVENT_SCHEDULES_SUCCESS = 'LOAD_EVENT_SCHEDULES_SUCCESS';
export const LOAD_EVENT_SCHEDULE = 'LOAD_EVENT_SCHEDULE';
export const LOAD_EVENT_SCHEDULE_SUCCESS = 'LOAD_EVENT_SCHEDULE_SUCCESS';
export const UPDATE_EVENT_SCHEDULE = 'UPDATE_EVENT_SCHEDULE';
export const UPDATE_EVENT_SCHEDULE_SUCCESS = 'UPDATE_EVENT_SCHEDULE_SUCCESS';
export const DELETE_EVENT_SCHEDULE = 'DELETE_EVENT_SCHEDULE';
export const DELETE_EVENT_SCHEDULE_SUCCESS = 'DELETE_EVENT_SCHEDULE_SUCCESS';

// Event
export const LOAD_EVENTS = 'LOAD_EVENTS';
export const LOAD_EVENTS_SUCCESS = 'LOAD_EVENTS_SUCCESS';
export const LOAD_DRAWER_EVENTS_SUCCESS = 'LOAD_DRAWER_EVENTS_SUCCESS';
export const LOAD_EVENT = 'LOAD_EVENT';
export const LOAD_EVENT_SUCCESS = 'LOAD_EVENT_SUCCESS';
export const UPDATE_EVENT = 'UPDATE_EVENT';
export const UPDATE_EVENT_SUCCESS = 'UPDATE_EVENT_SUCCESS';
export const DELETE_EVENT = 'DELETE_EVENT';
export const DELETE_EVENT_SUCCESS = 'DELETE_EVENT_SUCCESS';
export const LOAD_LIST_EVENT = 'LOAD_LIST_EVENT';

// Event type
export const LOAD_EVENT_TYPES = 'LOAD_EVENT_TYPES';
export const LOAD_EVENT_TYPES_SUCCESS = 'LOAD_EVENT_TYPES_SUCCESS';
export const UPDATE_EVENT_TYPE = 'UPDATE_EVENT_TYPE';
export const UPDATE_EVENT_TYPE_SUCCESS = 'UPDATE_EVENT_TYPE_SUCCESS';
export const DELETE_EVENT_TYPE = 'DELETE_EVENT_TYPE';
export const DELETE_EVENT_TYPE_SUCCESS = 'DELETE_EVENT_TYPE_SUCCESS';
export const CLEAR_EVENT_TYPES = 'CLEAR_EVENT_TYPES';

// Feed module
// ---------------
export const LOAD_NOTIFICATIONS = 'LOAD_NOTIFICATIONS';
export const LOAD_NOTIFICATIONS_SUCCESS = 'LOAD_NOTIFICATIONS_SUCCESS';
export const VIEW_NOTIFICATION = 'VIEW_NOTIFICATION';
export const VIEW_NOTIFICATION_SUCCESS = 'VIEW_NOTIFICATION_SUCCESS';
export const VIEW_ALL_NOTIFICATION = 'VIEW_ALL_NOTIFICATION';
export const VIEW_ALL_NOTIFICATION_SUCCESS = 'VIEW_ALL_NOTIFICATION_SUCCESS';
export const CHANGE_NOTIFICATION_FILTERS = 'CHANGE_NOTIFICATION_FILTERS';
export const DELETE_NOTIFICATION = 'DELETE_NOTIFICATION';
export const DELETE_NOTIFICATION_SUCCESS = 'DELETE_NOTIFICATION_SUCCESS';
export const APPEND_NEW_FEED = 'APPEND_NEW_FEED';

// Activity log module
export const LOAD_PROJECT_ACTIVITY_LOG = 'LOAD_PROJECT_ACTIVITY_LOG';
export const LOAD_PROJECT_ACTIVITY_LOG_SUCCESS = 'LOAD_PROJECT_ACTIVITY_LOG_SUCCESS';
export const LOAD_TASK_ACTIVITY_LOG = 'LOAD_TASK_ACTIVITY_LOG';
export const LOAD_TASK_ACTIVITY_LOG_SUCCESS = 'LOAD_TASK_ACTIVITY_LOG_SUCCESS';
export const LOAD_ACTIVITY_LOG_PROJECT_LIST = 'LOAD_ACTIVITY_LOG_PROJECT_LIST';
export const LOAD_ACTIVITY_LOG_PROJECT_LIST_SUCCESS = 'LOAD_ACTIVITY_LOG_PROJECT_LIST_SUCCESS';

// Company registration and set up
export const SIGN_UP_COMPANY = 'SIGN_UP_COMPANY';
export const SIGN_UP_COMPANY_SUCCESS = 'SIGN_UP_COMPANY_SUCCESS';
export const SIGN_UP_COMPANY_ERROR = 'SIGN_UP_COMPANY_ERROR';
export const VALIDATE_EMAIL = 'VALIDATE_EMAIL';
export const SIGN_UP_CONFIRM = 'SIGN_UP_CONFIRM';
export const SET_UP_COMPANY = 'SET_UP_COMPANY';
export const LOAD_COMPANY_BILLING = 'LOAD_COMPANY_BILLING';
export const LOAD_COMPANY_BILLING_SUCCESS = 'LOAD_COMPANY_BILLING_SUCCESS';
export const LOAD_COMPANY_RATE = 'LOAD_COMPANY_RATE';
export const LOAD_COMPANY_RATE_SUCCESS = 'LOAD_COMPANY_RATE_SUCCESS';
export const CHANGE_COMPANY_RATE = 'CHANGE_COMPANY_RATE';
export const CHANGE_COMPANY_RATE_SUCCESS = 'CHANGE_COMPANY_RATE_SUCCESS';
export const INVOICE_COMPANY = 'INVOICE_COMPANY';
export const INVOICE_COMPANY_SUCCESS = 'INVOICE_COMPANY_SUCCESS';
export const CARD_INVOICE_SUCCESS = 'CARD_INVOICE_SUCCESS';
export const PAYMENT_SUCCESS = 'PAYMENT_SUCCESS';
export const CREATE_COMPANY_EXPORT = 'CREATE_COMPANY_EXPORT';
export const CREATE_COMPANY_EXPORT_SUCCESS = 'CREATE_COMPANY_EXPORT_SUCCESS';
export const DOWNLOAD_COMPANY_EXPORT = 'DOWNLOAD_COMPANY_EXPORT';

// ===========================
// Rbac roles actions constants
// ===========================

// Rbac items
export const LOAD_RBAC_ITEMS = 'LOAD_RBAC_ITEMS';
export const LOAD_RBAC_ITEMS_SUCCESS = 'LOAD_RBAC_ITEMS_SUCCESS';

export const LOAD_USER_PERMISSIONS = 'LOAD_USER_PERMISSIONS';
export const LOAD_USER_PERMISSIONS_SUCCESS = 'LOAD_USER_PERMISSIONS_SUCCESS';

// ===========================
// UI actions constants
// ===========================

// Users page
export const TOGGLE_USER_VIEW = 'TOGGLE_USER_VIEW';
export const TOGGLE_DEPARTAMENT_VIEW = 'TOGGLE_DEPARTAMENT_VIEW';
export const CHANGE_USER_LIST_VIEW = 'CHANGE_USER_LIST_VIEW';

// Credentials list
export const CHANGE_CREDENTIAL_FILTERS = 'CHANGE_CREDENTIAL_FILTERS';
export const CHANGE_CREDENTIAL_CATEGORY = 'CHANGE_CREDENTIAL_CATEGORY';
export const CHANGE_CREDENTIAL_FILTER = 'CHANGE_CREDENTIAL_FILTER';
export const CHANGE_CREDENTIAL_SIDEBAR = 'CHANGE_CREDENTIAL_SIDEBAR';
export const TOGGLE_CREDENTIAL_VIEW = 'TOGGLE_CREDENTIAL_VIEW';

// Credential groups page
export const CHANGE_CREDENTIAL_GROUPS_SEARCH = 'CHANGE_CREDENTIAL_GROUPS_SEARCH';
export const TOGGLE_CREDENTIAL_GROUP_VIEW = 'TOGGLE_CREDENTIAL_GROUP_VIEW';

// Freelancers table
export const TOGGLE_FREELANCER_VIEW = 'TOGGLE_FREELANCER_VIEW';

// Service table
export const CHANGE_SERVICE_TABLE_SEARCH = 'CHANGE_SERVICE_TABLE_SEARCH';
export const TOGGLE_SERVICE_VIEW = 'TOGGLE_SERVICE_VIEW';

// Projects list
export const CHANGE_PROJECT_LIST_SEARCH = 'CHANGE_PROJECT_LIST_SEARCH';
export const CHANGE_PROJECT_LIST_VIEW = 'CHANGE_PROJECT_LIST_VIEW';
export const CHANGE_PROJECT_LIST_FILTERS = 'CHANGE_PROJECT_LIST_FILTERS';

// Project view
export const LOAD_PROJECT_CREDENTIALS = 'LOAD_PROJECT_CREDENTIALS';
export const LOAD_PROJECT_CREDENTIALS_SUCCESS = 'LOAD_PROJECT_CREDENTIALS_SUCCESS';
export const UPDATE_PROJECT_CREDENTIAL = 'UPDATE_PROJECT_CREDENTIAL';
export const UPDATE_PROJECT_CREDENTIAL_SUCCESS = 'UPDATE_PROJECT_CREDENTIAL_SUCCESS';
export const CHANGE_PROJECT_CREDENTIALS_FILTER = 'CHANGE_PROJECT_CREDENTIALS_FILTER';
export const CHANGE_PROJECT_CREDENTIALS_CATEGORY = 'CHANGE_PROJECT_CREDENTIALS_CATEGORY';
export const CHANGE_PROJECT_CREDENTIAL_PROJECT_ID = 'CHANGE_PROJECT_CREDENTIAL_PROJECT_ID';
export const TOGGLE_PROJECT_CREDENTIALS_SIDEBAR = 'CHANGE_PROJECT_CREDENTIALS_SIDEBAR';

export const CHANGE_PROJECT_SERVICES_SEARCH = 'CHANGE_PROJECT_SERVICES_SEARCH';
export const TOGGLE_SERVICE_MAP_VIEW = 'TOGGLE_SERVICE_MAP_VIEW';

export const CHANGE_PROJECT_TASKS_PROJECT_ID = 'CHANGE_PROJECT_TASKS_PROJECT_ID';
export const CHANGE_PROJECT_TASKS_FILTER = 'CHANGE_PROJECT_TASKS_FILTER';
export const TOGGLE_PROJECT_TASKS_SIDEBAR = 'TOGGLE_PROJECT_TASKS_SIDEBAR';
export const CHANGE_PROJECT_TASKS_LABEL_ID = 'CHANGE_PROJECT_TASKS_LABEL_ID';
export const LOAD_PROJECTS_IMPORTANT_PAGES = 'LOAD_PROJECTS_IMPORTANT_PAGES';
export const LOAD_PROJECTS_IMPORTANT_PAGES_SUCCESS = 'LOAD_PROJECTS_IMPORTANT_PAGES_SUCCESS';
export const UPDATE_PROJECTS_IMPORTANT_PAGE = 'UPDATE_PROJECTS_IMPORTANT_PAGE';
export const UPDATE_PROJECTS_IMPORTANT_PAGE_SUCCESS = 'UPDATE_PROJECTS_IMPORTANT_PAGE_SUCCESS';
export const DELETE_PROJECTS_IMPORTANT_PAGE = 'DELETE_PROJECTS_IMPORTANT_PAGE';
export const DELETE_PROJECTS_IMPORTANT_PAGE_SUCCESS = 'DELETE_PROJECTS_IMPORTANT_PAGE_SUCCESS';

export const BATCH_UPDATE_PROJECTS_IMPORTANT_PAGE = 'BATCH_UPDATE_PROJECTS_IMPORTANT_PAGE';
export const BATCH_UPDATE_PROJECTS_IMPORTANT_PAGE_SUCCESS = 'BATCH_UPDATE_PROJECTS_IMPORTANT_PAGE_SUCCESS';

// Tasks list
export const CHANGE_TASK_FILTER = 'CHANGE_TASK_FILTER';
export const CHANGE_TASK_LABEL_ID = 'CHANGE_TASK_LABEL_ID';
export const CHANGE_TASK_SIDEBAR = 'CHANGE_TASK_SIDEBAR';
export const CHANGE_TASK_STATUS_ID = 'CHANGE_TASK_STATUS_ID';
export const TOGGLE_COMMENT_FORM_FOCUS = 'TOGGLE_COMMENT_FORM_FOCUS';
export const SELECT_TASK_BATCH = 'SELECT_TASK_BATCH';
export const REMOVE_TASK_BATCH = 'REMOVE_TASK_BATCH';
export const CLEAR_TASK_BATCH = 'CLEAR_TASK_BATCH';
export const SELECT_ALL_TASKS_BATCH = 'SELECT_ALL_TASKS_BATCH';

// Clients table
export const CHANGE_CLIENT_TABLE_SEARCH = 'CHANGE_CLIENT_TABLE_SEARCH';

// Articles list
export const LOAD_ARTICLES_LIST_SUCCESS = 'LOAD_ARTICLES_LIST_SUCCESS';
export const TOGGLE_ARTICLE_BAR = 'TOGGLE_ARTICLE_BAR';

// Event table
export const TOGGLE_EVENT_VIEW = 'TOGGLE_EVENT_VIEW';

// Analytics
export const LOAD_SERVICE_ANALYTICS_SUCCESS = 'LOAD_SERVICE_ANALYTICS_SUCCESS';

// Forms
export const SELECT_TASK_FORM_PROJECT = 'SELECT_TASK_FORM_PROJECT';
export const TOGGLE_TASK_VIEW = 'TOGGLE_TASK_VIEW';
export const TOGGLE_DISMISS_PROFILE_FORM = 'TOGGLE_DISMISS_PROFILE_FORM';
export const TOGGLE_ARTICLE_FORM = 'TOGGLE_ARTICLE_FORM';
export const TOGGLE_ARTICLE_CATEGORY_FORM = 'TOGGLE_ARTICLE_CATEGORY_FORM';
export const TOGGLE_ARTICLE_TAG_FORM = 'TOGGLE_ARTICLE_TAG_FORM';
export const TOGGLE_EVENT_FORM = 'TOGGLE_EVENT_FORM';
export const TOGGLE_EVENT_TYPE_FORM = 'TOGGLE_EVENT_TYPE_FORM';
export const TOGGLE_DEPARTMENT_FORM = 'TOGGLE_DEPARTMENT_FORM';
export const TOGGLE_POSITION_FORM = 'TOGGLE_POSITION_FORM';
export const TOGGLE_ROLE_FORM = 'TOGGLE_ROLE_FORM';
export const TOGGLE_USER_ROLE_FORM = 'TOGGLE_USER_ROLE_FORM';

export const TOGGLE_USER_INVITE_FORM = 'TOGGLE_USER_INVITE_FORM';
export const TOGGLE_CLIENT_FORM = 'TOGGLE_CLIENT_FORM';
export const TOGGLE_CREDENTIAL_FORM = 'TOGGLE_CREDENTIAL_FORM';
export const TOGGLE_CREDENTIAL_GROUP_FORM = 'TOGGLE_CREDENTIAL_GROUP_FORM';
export const TOGGLE_FREELANCER_FORM = 'TOGGLE_FREELANCER_FORM';
export const TOGGLE_SERVICE_FORM = 'TOGGLE_SERVICE_FORM';
export const TOGGLE_PROJECT_FORM = 'TOGGLE_PROJECT_FORM';
export const CLEAR_PROJECT_FORM_ERRORS = 'CLEAR_PROJECT_FORM_ERRORS';
export const TOGGLE_SERVICE_MAP_FORM = 'TOGGLE_SERVICE_MAP_FORM';
export const TOGGLE_INVOICE_FORM = 'TOGGLE_INVOICE_FORM';
export const TOGGLE_ARCHIVE_PROJECT_FORM = 'TOGGLE_ARCHIVE_PROJECT_FORM';
export const TOGGLE_CLIENT_INVITATION_FORM = 'TOGGLE_CLIENT_INVITATION_FORM';
export const TOGGLE_TIMER_FORM = 'TOGGLE_TIMER_FORM';
export const TOGGLE_USER_CLIENT_FORM = 'TOGGLE_USER_CLIENT_FORM';
export const TOGGLE_LEGAL_ENTITY_FORM = 'TOGGLE_LEGAL_ENTITY_FORM';
export const TOGGLE_TASK_LABEL_FORM = 'TOGGLE_TASK_LABEL_FORM';
export const TOGGLE_MODERATE_FORM = 'TOGGLE_MODERATE_FORM';
export const TOGGLE_USER_CHANGE_PASSWORD_FORM = 'TOGGLE_USER_CHANGE_PASSWORD_FORM';
export const TOGGLE_TASK_MIGRATE_FORM = 'TOGGLE_TASK_MIGRATE_FORM';
export const TOGGLE_COMMENT_MIGRATE_FORM = 'TOGGLE_COMMENT_MIGRATE_FORM';
export const CLEAR_TASK_MIGRATE_FORM_DATASET = 'CLEAR_TASK_MIGRATE_FORM_DATASET';
export const CLEAR_COMMENT_MIGRATE_FORM_DATASET = 'CLEAR_COMMENT_MIGRATE_FORM_DATASET';
export const TOGGLE_PROJECTS_IMPORTANT_PAGE_FORM = 'TOGGLE_PROJECTS_IMPORTANT_PAGE_FORM';
export const TOGGLE_TASK_SCHEDULE_FORM = 'TOGGLE_TASK_SCHEDULE_FORM';
export const TOGGLE_EVENT_SCHEDULE_FORM = 'TOGGLE_EVENT_SCHEDULE_FORM';
export const TOGGLE_TASK_POPOVER_CONFIRM = 'TOGGLE_TASK_POPOVER_CONFIRM';

// ===========================
// Files actions constants
// ===========================
// Files uploading
export const UPLOAD_FILE = 'UPLOAD_FILE';
export const STOP_UPLOAD_FILE = 'STOP_UPLOAD_FILE';
export const UPLOAD_FILE_PROGRESS = 'UPLOAD_PROGRESS';
export const UPLOAD_FILE_FAILURE = 'UPLOAD_FAILURE';
export const UPLOAD_FILE_SUCCESS = 'UPLOAD_SUCCESS';
export const UPLOAD_ENTITY_FILE_SUCCESS = 'UPLOAD_ENTITY_FILE_SUCCESS';

// Files CRUD
export const DELETE_FILE = 'DELETE_FILE';
export const DELETE_FILE_SUCCESS = 'DELETE_FILE_SUCCESS';
export const DOWNLOAD_FILE = 'DOWNLOAD_FILE';
export const DOWNLOAD_ALL_FILES = 'DOWNLOAD_ALL_FILES';
export const DOWNLOAD_FILE_SUCCESS = 'DOWNLOAD_FILE_SUCCESS';

// Files list in form
export const CLEAR_FILES_LIST = 'CLEAR_FILES_LIST';
export const SET_FILES_LIST = 'SET_FILES_LIST';

// Search
export const LOAD_SEARCH_COMMENTS = 'LOAD_SEARCH_COMMENTS';
export const LOAD_SEARCH_COMMENTS_SUCCESS = 'LOAD_SEARCH_COMMENTS_SUCCESS';
export const CLEAN_SEARCH_COMMENTS = 'CLEAN_SEARCH_COMMENTS';

export const APP_UI_CHANGE_THEME_LIGHT = 'light';
export const APP_UI_CHANGE_THEME_DARK = 'dark';
